import { Component, OnInit, Input } from "@angular/core";
import { GeocodingModel } from "src/app/models/location.model";
import { ExternalService } from "src/app/services/external/external.service";
import { SaleService } from "src/app/services/sale/sale.service";

@Component({
  selector: "address",
  templateUrl: "./address.component.html",
  styleUrls: ["./address.component.scss"]
})
export class AddressComponent implements OnInit {
  @Input()
  deliveryType:string;

  @Input()
  geocoding:GeocodingModel = {};

  @Input()
  title:string;

  @Input()
  showFullAddress:boolean = false;

  constructor(public externalService:ExternalService, public saleService:SaleService) {
  }

  ngOnInit(): void {
    //
  }
}
